"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var Breadcrumbs = /** @class */ (function (_super) {
    tslib_1.__extends(Breadcrumbs, _super);
    function Breadcrumbs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Breadcrumbs.prototype.render = function () {
        var items = this.props.items;
        return (react_1.default.createElement("div", { className: "breadcrumbs" }, items.map(function (item, index) {
            var Component = item.href ? 'a' : 'span';
            return (react_1.default.createElement(react_1.default.Fragment, { key: item.name },
                react_1.default.createElement(Component, { className: "breadcrumbs__item", href: item.href }, item.name),
                index !== items.length - 1 && ' > '));
        })));
    };
    Breadcrumbs = tslib_1.__decorate([
        mobx_react_1.observer
    ], Breadcrumbs);
    return Breadcrumbs;
}(react_1.default.Component));
exports.Breadcrumbs = Breadcrumbs;
